module.exports = __webpack_public_path__ + "qaumi1-e885d21e6939740122d1.jpg";